<template>
  <div
    ref="addToCartButton"
    :class="[
      'relative-position',
      showFullFillment ? 'product-cart' : '',
      showLoader ? 'product-cart-loading' : '',
    ]"
    v-if="isinstock"
  >
    <div v-if="isItemInCart" class="added-cart">
      <!-- Loader -->
      <q-inner-loading
        :showing="showLoader"
        style="background: rgb(0 0 0 / 32%); border-radius: 4px"
      >
        <q-spinner color="white" size="20px" :thickness="3" />
      </q-inner-loading>
      <!-- Loader -->
      <div
        v-if="showFullFillment"
        class="icon hover"
        @click="isMobile && updateDialogState(true)"
      >
        <SvgIcon
          size="1rem"
          class="delivery-mode q-pt-xs"
          :icon="deliveryMode"
        />
      </div>
      <div class="btn items-center no-wrap">
        <q-btn
          @click="addItemInCart(-1)"
          round
          dense
          flat
          :icon="cartQty <= 1 ? 'delete' : 'remove'"
          size="0.6rem"
        />
        <q-input
          @blur="onQtyBlur"
          @focus="focus = true"
          class="text-center col-6 qtyGroup"
          rounded
          outlined
          mask="####"
          v-model="cartQty"
          dense
          @keyup.enter="$event.target.blur()"
          unmasked-value
        />
        <q-btn
          :class="[isDisableAddBtn ? 'disable' : '']"
          @click="addItemInCart(1)"
          round
          dense
          flat
          icon="add"
          size="0.6rem"
        />
      </div>
    </div>
    <div
      v-else-if="showFullFillment"
      :class="[
        'add-cart ',
        isItemHasSelectedFulFillmentOption ? 'addDelivery' : 'hover',
      ]"
      @click="
        !isItemHasSelectedFulFillmentOption &&
        isMobile &&
        updateDialogState(true)
      "
    >
      <!-- Loader -->
      <q-inner-loading
        :showing="showLoader"
        style="background: rgb(0 0 0 / 32%); border-radius: 4px"
      >
        <q-spinner color="white" size="20px" :thickness="3" />
      </q-inner-loading>
      <!-- Loader -->
      <!-- Need to add class when user added this item: addDelivery  -->
      <div
        class="full-width flex items-center justify-center"
        @click="
          !disable && isItemHasSelectedFulFillmentOption && addItemInCart(1)
        "
      >
        <div class="icon" v-if="deliveryMode">
          <SvgIcon size="1rem" class="delivery-mode" :icon="deliveryMode" />
        </div>
        <div class="btn">Add to Cart</div>
      </div>
      <!-- <div
        :class="['arrow ', isItemHasSelectedFulFillmentOption ? 'hover' : '']"
      >
        <div class="ar" @click="isMobile && updateDialogState(true)">
          <SvgIcon icon="arrow-angle-right" />
        </div>
      </div> -->
    </div>
  </div>
  <div
    :class="[
      'relative-position',
      isOnDetailPage ? 'product-detail-actions' : 'product-card-actions',
    ]"
    v-else
  >
    <div class="outstock-btn">
      <span>Out of Stock</span>
    </div>
    <!-- CARD -->
    <q-btn
      v-if="!isOnDetailPage"
      flat
      round
      dense
      icon="notifications_none"
      class="notify-btn"
      :disable="loading"
      :loading="loading"
      @mousedown.prevent
      @click.stop="setNotificationForProduct"
    >
      <q-tooltip v-if="!loading">Notify Me</q-tooltip>
    </q-btn>

    <!-- DETAIL PAGE -->
    <q-btn
      v-else
      unelevated
      no-caps
      :icon="'notifications_none'"
      label="Notify Me"
      :disable="loading"
      :loading="loading"
      @click="setNotificationForProduct"
      class="notify-full-btn"
    />
  </div>
</template>

<script>
import { testModePaymentMessage } from 'src/constants'
import { useDiscountStore } from 'src/stores/discounts'
import { useWishlistStore } from 'src/stores/wishlist'
import { useGuestStore } from 'src/stores/guest'
import { useCartStore } from 'src/stores/cart'
import { usePersistedLocalStore } from 'src/stores/persisted-local'
import { useCommonStore } from 'src/stores/common'
import { mapState } from 'pinia'
import { usePlatform } from 'src/composables/usePlatform'
import { trackAddToCart, trackRemoveFromCart } from 'src/utils/ga4'
import { useProductStore } from 'src/stores/product'
import { useAgeVerificationStore } from 'src/stores/age-verification'

export default {
  name: 'AddToCartBtn',
  props: {
    isinstock: {
      type: Boolean,
      default: true,
    },
    productId: {
      type: String,
      default: () => {
        return ''
      },
    },
    productFulFillments: {
      type: Array,
      default: () => {
        return new Array()
      },
    },
    showFullFillment: {
      type: Boolean,
      default: true,
    },
    cartLineItem: {
      type: Object,
      default: null,
    },
    fulFillmentCodeName: {
      type: String,
      default: '',
    },
    showMaxErrorOnTop: {
      type: Boolean,
      default: true,
    },
    isOnDetailPage: {
      type: Boolean,
      default: false,
    },
    onDeliveryModeChnaged: {
      type: Function,
      default: null,
    },
    applyCoupon: {
      type: Boolean,
      default: false,
    },
    showFlyAnimation: {
      type: Boolean,
      default: true,
    },
    allowAutoShip: {
      type: Boolean,
      default: false,
    },
    subscriptionDetails: {
      type: Object,
      default: () => {
        return {}
      },
    },
    productFamily: {
      type: Number,
      default: 0,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    giftCardAmount: {
      type: [Number, String],
      default: null,
    },
    giftCardId: {
      type: String,
      default: null,
    },
    quantity: {
      type: Number,
      default: null,
    },
    onAddToCart: {
      type: Function,
      default: null,
    },
    showUpdateQty: {
      type: Boolean,
      default: true,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    validateMaxQty: {
      type: Boolean,
      default: true,
    },

    productName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showLoader: false,
      showMaxError: false,
      showMaxErrorTimer: null,
      focus: false,
      timer: null,
      hover: false,
      cartDelivery: '',
      noOfItemsInCart: null,
      cartDialogState: false,
      loading: false,
      wishlistStore: useWishlistStore(),
      cartStore: useCartStore(),
      persistedLocalStore: usePersistedLocalStore(),
      commonStore: useCommonStore(),
      productStore: useProductStore(),
    }
  },
  computed: {
    ...mapState(useCartStore, [
      'currentCartDetails',
      'getProductById',
      'currentCartNumber',
    ]),
    ...mapState(useWishlistStore, ['allowAddToCart']),
    ...mapState(useDiscountStore, ['currentDiscount']),
    ...mapState(useGuestStore, ['guestCartNumber']),
    ...mapState(usePersistedLocalStore, ['getCartPersistedInfo']),
    ...mapState(useAgeVerificationStore, ['isUserAgeVerified']),
    cartQty: {
      get() {
        return this.noOfItemsInCart !== null
          ? this.noOfItemsInCart
          : this.cartItemInfo.orderLineItemID
            ? this.cartItemInfo.cartQty
            : 0
      },
      set(value) {
        this.noOfItemsInCart = value ? value : 0
      },
    },
    deliveryMode() {
      return this.selectedFulfillmentCodeName
    },
    isItemHasSelectedFulFillmentOption() {
      if (this.$route.name === 'GiftCardDetail') return true
      return !!this.selectedFulFillment
    },
    fulFillmentId() {
      return this.selectedFulfillment?.fulfillmentId
      // for (let fulFillment of this.productFulFillments) {
      //   if (fulFillment.codeName == this.deliveryMode) {
      //     return fulFillment.fulfillmentMethodID
      //   }
      // }

      // return ''
    },
    selectedFulFillment() {
      return (
        this.productFulFillments.find(
          (f) => f.codeName === this.deliveryMode
        ) || null
      )
    },
    cartItemInfo() {
      if (this.cartLineItem) {
        return {
          cartQty: this.cartLineItem.qty,
          orderLineItemID: this.cartLineItem.orderLineItemID,
          cartDelivery: this.fulFillmentCodeName,
          orderLineItemOrderType: this.cartLineItem.orderLineItemOrderType,
        }
      }

      // Default cart item information
      let cartItemInfo = {
          cartQty: 0,
          orderLineItemID: '',
          cartDelivery: '',
          orderLineItemOrderType: 0,
        },
        cartDetails = this.currentCartDetails

      if (!cartDetails?.orderID) {
        return cartItemInfo
      }

      for (const fulfillment of Object.values(cartDetails.fulfillments || {})) {
        if (!fulfillment.shoppingCartItems) continue
        const item = Object.values(fulfillment.shoppingCartItems).find((item) =>
          this.validateCartItem(item)
        )

        if (item) {
          cartItemInfo = {
            cartQty: item.qty,
            orderLineItemID: item.orderLineItemID,
            cartDelivery: fulfillment.codeName,
            orderLineItemOrderType: item.orderLineItemOrderType,
          }
        }
      }

      return cartItemInfo
    },
    isItemInCart() {
      return this.cartItemInfo.orderLineItemID && this.showUpdateQty
        ? true
        : false
    },
    flyElClass() {
      let className = '.shopping-cart'
      if (this.$route.name == 'Home' && this.isMobile) {
        className = '.shopping-cart-footer'
      }
      return className
    },
    cartPersistedInfo() {
      return this.getCartPersistedInfo(this.currentCartNumber)
    },
    getItemOrderType() {
      let type = 0
      if (this.productFamily) type = this.productFamily
      else if (this.subscriptionDetails.hasOwnProperty('subscriptionOption'))
        type = this.subscriptionDetails.subscriptionOption == 2 ? 1 : 0
      else if (
        this.isItemInCart &&
        this.cartItemInfo?.hasOwnProperty('orderLineItemOrderType')
      )
        type = this.cartItemInfo.orderLineItemOrderType
      return type
    },
    isGuestAllowed() {
      let isAllow = true
      if (
        !this.isItemInCart &&
        this.isOnDetailPage &&
        this.allowAutoShip &&
        this.subscriptionDetails?.subscriptionOption == 2
      )
        isAllow = false
      else if (this.businessConfigurations?.enableGuestCheckout === false)
        isAllow = false
      return isAllow
    },
    getProduct() {
      if (this.giftCardId !== null)
        return {
          productId: this.giftCardId,
          qty: this.cartQty,
          instruction: this.getProductInstruction(),
          orderLineItemOrderType: this.getItemOrderType,
          giftCardAmount: this.giftCardAmount,
        }

      return {
        productId: this.productId,
        qty: this.cartQty,
        instruction: this.getProductInstruction(),
        orderLineItemOrderType: this.getItemOrderType,
      }
    },
    isDisableAddBtn() {
      if (!this.getProductQtyLimit) return false
      return this.cartQty >= this.getProductQtyLimit
    },
    getProductQtyLimit() {
      const { allowOutOfStockSell } = this.businessConfigurations || {}

      if (!this.getQtyLimit) return 0
      if (allowOutOfStockSell) return this.getQtyLimit
      if (!this.getInventoryLimit) return this.getQtyLimit

      return Math.min(this.getQtyLimit, this.getInventoryLimit)
    },
    getQtyLimit() {
      return (
        this.selectedFulFillment?.qtyLimit ?? this.cartLineItem?.qtyLimit ?? 0
      )
    },
    getInventoryLimit() {
      return (
        this.selectedFulFillment?.inventoryLimit ??
        this.cartLineItem?.inventoryLimit ??
        0
      )
    },
    isTestModeWithoutGateway() {
      return (
        this.businessConfigurations?.mode === 2 &&
        this.businessConfigurations?.currentPaymentGateway == null
      )
    },
    requiresCustomerSignup() {
      return this.isLoggedIn && !this.customerExists
    },
    canProceedAsUser() {
      return this.isLoggedIn || (!this.isLoggedIn && this.isGuestAllowed)
    },
    isGiftCardPurchaseAllowed() {
      if (
        !this.isUserAgeVerified &&
        [2, 3].includes(this.productFamily) &&
        this.businessConfigurations?.allowGiftCardForVerifiedAge &&
        this.businessConfigurations?.enableAgeRestrictedBrowsing
      )
        return false
      return true
    },
  },
  mounted() {
    if (this.isItemHasSelectedFulFillmentOption && !this.allowAddToCart) {
      this.wishlistStore.enableAddToCartForWishlist(this.fulFillmentId)
    }
  },
  watch: {
    'cartItemInfo.cartQty': function (newVal, oldVal) {
      if (newVal != oldVal && this.cartQty != newVal) {
        let timeout =
          this.$route.name == 'GiftCardDetail' || this.isDialog ? 0 : 100
        setTimeout(() => (this.cartQty = newVal), timeout)
      }
    },
    'cartItemInfo.cartDelivery': function (newVal, oldVal) {
      if (newVal != oldVal && this.cartDelivery != newVal)
        this.cartDelivery = newVal
    },
    fulFillmentId: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.wishlistStore.enableAddToCartForWishlist(newVal)
        }
      },
      deep: true,
    },
  },
  methods: {
    getAnalyticsItem(productInfo) {
      if (productInfo) return productInfo

      const fallbackTitle =
        this.cartLineItem?.title ||
        this.cartLineItem?.itemName ||
        this.cartLineItem?.name ||
        ''
      const fallbackSku =
        this.cartLineItem?.seoName ||
        this.cartLineItem?.sku ||
        this.cartLineItem?.productSku ||
        ''
      const fallbackId =
        this.giftCardId !== null && this.giftCardId !== undefined
          ? this.giftCardId
          : this.productId

      return {
        productId: fallbackId,
        productID: fallbackId,
        id: fallbackId,
        seoName: fallbackSku || fallbackId,
        sku: fallbackSku || fallbackId,
        title: fallbackTitle || fallbackSku || fallbackId,
        name: fallbackTitle || fallbackSku || fallbackId,
        price: Number(this.cartLineItem?.price || this.giftCardAmount || 0),
      }
    },
    getProductInstruction() {
      let productInfo = this.getProductById(this.productId)
      return productInfo?.instruction || ''
    },
    updateDialogState(val) {
      this.cartDialogState = val
    },
    async deliveryModeChanged(deliveryMode) {
      this.cartDialogState = false

      this.cartDelivery = deliveryMode
      this.cartQty = this.cartItemInfo.qty

      // if (this.cartItemInfo.orderLineItemID)
      //   this.cartStore.toggleSubstitute({
      //     orderLineItemId: this.cartItemInfo.orderLineItemID,
      //     allowSubstitute: false,
      //   })

      if (!this.isItemInCart) {
        this.addItemInCart(1)
      } else {
        this.cartQty = this.cartItemInfo.cartQty

        this.checkMaxLimit()

        this.setLoading(true)

        await this.cartStore.addUpdateCartDetail({
          fulfillmentMethodId: this.fulFillmentId,
          products: [{ ...this.getProduct }],
        })

        this.setLoading(false)

        this.onAddToCart && this.onAddToCart()
        this.notify('Item Updated to Cart.')
        this.wishlistStore.enableAddToCartForWishlist(this.fulFillmentId)
      }

      if (this.onDeliveryModeChnaged) this.onDeliveryModeChnaged()
    },
    checkMaxLimit() {
      if (this.cartQty >= this.getProductQtyLimit) {
        this.showMaxError = true

        if (this.showMaxErrorTimer) {
          clearTimeout(this.showMaxErrorTimer)
          this.showMaxErrorTimer = null
        }

        this.showMaxErrorTimer = setTimeout(() => {
          this.showMaxError = false
        }, 2000)

        this.cartQty = this.getProductQtyLimit
      }
    },
    async addItemInCart(incrementQty) {
      incrementQty = this.showUpdateQty ? incrementQty : this.quantity
      if (this.isTestModeWithoutGateway) {
        return this.showError(testModePaymentMessage)
      }

      if (this.requiresCustomerSignup) {
        return this.signUpConfirm().onOk(() =>
          this.addItemInCartCore(incrementQty)
        )
      }

      if (!this.canProceedAsUser) {
        return this.openAccountDrawer()
      }

      if (!this.isGiftCardPurchaseAllowed)
        return this.showError(
          'Gift Cards can only be purchased by age-verified customers so verify your age.'
        )

      return this.addItemInCartCore(incrementQty)
    },
    async addItemInCartCore(incrementQty) {
      const previousQty = this.cartItemInfo.cartQty || 0
      let newQty = this.calculateNewQty(incrementQty)

      const limitError = this.validateQuantity(newQty)

      if (limitError) {
        this.showError(limitError)

        const maxLimit = this.getProductQtyLimit
        if (maxLimit) {
          newQty = Math.min(newQty, maxLimit)
        }
      }

      if (newQty <= 0) {
        return this.removeItemFromCart(previousQty)
      }

      // Prevent unnecessary API call
      if (newQty === previousQty) {
        this.cartQty = newQty
        return
      }

      this.cartQty = newQty
      if (![2, 3].includes(this.productFamily)) this.checkMaxLimit()
      this.debounceCartUpdate(previousQty, newQty, !!limitError)
    },
    calculateNewQty(incrementQty) {
      const current = parseInt(this.cartQty) || 0
      const increment = parseInt(incrementQty) || 0
      return Math.max(current + increment, 0)
    },
    async removeItemFromCart(previousQty) {
      this.clearTimer()
      this.setLoading(true)

      await this.cartStore.deleteCartItem({
        orderItemId: this.cartItemInfo.orderLineItemID,
      })

      this.setLoading(false)
      this.notify('Item Removed from Cart.')
      const analyticsProductId =
        this.giftCardId !== null && this.giftCardId !== undefined
          ? this.giftCardId
          : this.productId
      const productInfoForRemove = this.getProductById(analyticsProductId)

      if (previousQty > 0) {
        trackRemoveFromCart({
          item: this.getAnalyticsItem(productInfoForRemove),
          quantity: previousQty,
        })
      }
    },
    validateQuantity(newQty) {
      if (!this.validateMaxQty) return null
      if (this.businessConfigurations?.allowOutOfStockSell) return null

      const stockLimit = this.getInventoryLimit
      const qtyLimit = this.getQtyLimit

      if (stockLimit > 0 && newQty > stockLimit) {
        return `Only ${stockLimit} Qty left in stock so you cannot add more than ${stockLimit} to your cart!`
      }

      if (qtyLimit > 0 && newQty > qtyLimit) {
        return `${qtyLimit} is the maximum purchase limit for an item, so you can’t place an order with more than ${qtyLimit} Qty.`
      }

      return null
    },
    debounceCartUpdate(previousQty, newQty, hasValidationError = false) {
      this.clearTimer()

      this.timer = setTimeout(
        () => {
          this.performCartUpdate(previousQty, newQty, hasValidationError)
        },
        this.isItemInCart ? 400 : 0
      )
    },
    async performCartUpdate(previousQty, newQty, hasValidationError) {
      const params = {
        fulfillmentMethodId: this.fulFillmentId,
        products: [{ ...this.getProduct }],
      }

      this.setLoading(true)

      if (!this.currentCartDetails?.orderID) {
        this.cartStore.setField({ field: 'isTipConfirmed', value: false })
      }

      const response = await this.cartStore.addUpdateCartDetail(params)

      this.setLoading(false)

      if (response?.success) {
        this.handleCartSuccess(
          response,
          previousQty,
          newQty,
          hasValidationError
        )
      } else if (response?.errors?.length) {
        this.handleCartErrors(response.errors)
      }
    },
    handleCartSuccess(response, previousQty, newQty, hasValidationError) {
      this.cartQty = this.cartItemInfo.cartQty
      const diffQty = this.cartQty - previousQty
      const analyticsProductId =
        this.giftCardId !== null && this.giftCardId !== undefined
          ? this.giftCardId
          : this.productId
      const productInfo = this.getProductById(analyticsProductId)

      if ((previousQty === 0 && newQty === 1) || this.quantity) {
        this.handleAddNotification()

        if (this.allowAutoShip && response.data?.orderNumber) {
          this.persistSubscription(response.data.orderNumber)
        }
      } else if (!hasValidationError) {
        this.handleUpdateNotification(newQty)
      }

      if (diffQty !== 0) {
        const analyticsItem = this.getAnalyticsItem(productInfo)
        if (diffQty > 0) {
          trackAddToCart({
            item: analyticsItem,
            quantity: diffQty,
          })
        } else {
          trackRemoveFromCart({
            item: analyticsItem,
            quantity: Math.abs(diffQty),
          })
        }
      }
      this.onAddToCart && this.onAddToCart()
      if (this.applyCoupon && this.currentDiscount?.couponCode) {
        this.applyDiscountCoupons(this.currentDiscount.couponCode)
      }
    },
    handleAddNotification() {
      if (this.showFlyAnimation && window.flyToElement) {
        window.flyToElement(
          this.$refs.addToCartButton,
          this.flyElClass,
          this.isOnDetailPage
        )
      } else {
        this.notify('Item Added to Cart.')
      }
    },
    handleUpdateNotification(newQty) {
      // If out-of-stock selling is allowed → always notify update
      /* if (this.businessConfigurations?.allowOutOfStockSell) {
        this.notify('Item Updated to Cart.')
        return
      }

      const limitError = this.validateQuantity(newQty)
      if (limitError) {
        this.showError(limitError)
        return
      }

      this.notify('Item Updated to Cart.') */
      this.notify('Item Updated to Cart.')
    },
    persistSubscription(orderNumber) {
      const productInfo = this.getProductById(this.productId)
      if (!productInfo) return

      const existing = this.cartPersistedInfo?.subscriptionDetails || {}

      const updated = {
        ...this.subscriptionDetails,
        productID: this.productId,
      }

      this.persistedLocalStore.setCartPersistedInfo({
        cartNumber: orderNumber,
        data: {
          subscriptionDetails: {
            ...existing,
            [productInfo.orderLineItemID]: updated,
          },
        },
      })
    },
    handleCartErrors(errors) {
      this.cartQty = this.cartItemInfo.cartQty

      errors.forEach((error) => {
        switch (error.errorCode) {
          case 'CRT_400':
            this.handleFulfillmentError()
            break

          case 'CRT_1010':
            this.changeDialogState({
              dialog: 'BlacklistProductMsgDialog',
              val: true,
              properties: { dialogTitle: error.descreption },
              parentDialog: 'QuickProductDetailDialog',
            })
            break

          case 'CRT_0114':
            this.cartQty = this.cartItemInfo.cartQty
            this.ftxConfirmCoupon(
              '',
              error.descreption,
              false,
              'Ok',
              true,
              false,
              'info-filled',
              '3em',
              true,
              false,
              false,
              true
            )
            break
        }
      })
    },
    async handleFulfillmentError() {
      this.setLoading(true)

      try {
        await this.commonStore.getConfiguration()
      } finally {
        this.setLoading(false)

        const title =
          'The fulfillment method is unavailable for your selected location (store) currently. How would you like to place your order?'

        this.changeDialogState({
          dialog: 'changeLocation',
          val: true,
          properties: {
            dialogTitle: title,
            persistentDialog: true,
          },
        })
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    openAccountDrawer() {
      return this.changeDialogState({
        dialog: 'accountDrawer',
        val: true,
      })
    },
    async applyDiscountCoupons(discountCoupon) {
      if (discountCoupon) {
        try {
          let requestObj = {
            DiscountCouponCode: discountCoupon,
          }
          if (!this.isLoggedIn && this.guestCartNumber)
            requestObj.OrderNumber = this.guestCartNumber
          let res = await this.cartStore.applyDiscountCoupons(requestObj)
          if (
            res.success &&
            res.data.errorMessage &&
            !res.data.errorMessage.length
          ) {
            this.ftxConfirmCoupon(
              '',
              'Yay! Coupon is applied',
              'Cancel',
              'Ok',
              true,
              false,
              '',
              '',
              false,
              true,
              false,
              false
            )
          }
        } catch (error) {}
      }
    },
    notify(message) {
      this.showSuccess(
        message,
        this.$route.name != 'Cart' && this.cartQty > 0
          ? [
              {
                color: 'dark',
                label: 'View Cart',
                color: 'orange-5',
                handler: () => {
                  if (this.isMobile)
                    this.$router
                      .push({
                        name: 'Cart',
                      })
                      .catch(() => {})
                  else
                    this.changeDialogState({
                      dialog: 'cartDrawer',
                      val: true,
                    })
                },
              },
            ]
          : []
      )
    },
    setLoading(loading = false) {
      this.showLoader = loading
    },
    onQtyBlur() {
      this.focus = false
      if (this.cartQty != this.cartItemInfo.cartQty) this.addItemInCart(0)
    },
    validateCartItem(item) {
      // Gift card
      if (this.giftCardId !== null) {
        return (
          item.productId === this.giftCardId &&
          Number(item.price) === Number(this.giftCardAmount)
        )
      }

      // Normal product
      return item.productId === this.productId
    },
    setNotificationForProduct() {
      if (!this.productId) return

      if (this.isLoggedIn && this.customer.emailID) this.notifyLoggedInUser()
      else this.notifyUserWithoutEmail()
    },
    async notifyLoggedInUser() {
      this.loading = true

      let body = {
        productID: this.productId,
        locationID: this.currentLocationId,
        // emailID: this.customer.emailID,
        customerID: this.customer?.customerID,
      }
      let response = await this.productStore.setProductNotification(body)
      this.loading = false
      if (response && response.success) {
        return this.showSuccess(
          `You will be notified through your registered email when "${this.productName}" is back in stock!`
        )
      } else if (response?.errors && response?.errors?.length > 0)
        return this.showError(
          response?.errors[0]?.descreption || 'Something went wrong.'
        )
    },
    async notifyUserWithoutEmail() {
      this.changeDialogState({
        dialog: 'NotifyDialog',
        val: true,
        properties: {
          productId: this.productId,
          productName: this.productName,
          isOnlyEmail: this.isLoggedIn ?? false,
        },
      })
    },
  },
  setup() {
    const { isMobile } = usePlatform()
    return { isMobile }
  },
}
</script>
<style lang="scss">
.h-search-2 {
  .q-list {
    .q-item {
      &:not(:nth-of-type(1)):not(:nth-of-type(2)):not(:nth-of-type(3)) {
        .product-cart .dropdown {
          bottom: calc(100% - 1px);
          top: auto;
        }
      }
    }
  }
  .q-scrollarea {
    min-height: 330px;
  }
  &.one-record {
    .q-scrollarea {
      max-height: 220px;
      min-height: 220px;
    }
  }
  &.two-record {
    .q-scrollarea {
      max-height: 270px;
      min-height: 270px;
    }
  }
}

/* .product-cart {
  position: relative;
  width: 100%;
  .q-btn {
    font-family: 'Lato', Arial, sans-serif;
    font-weight: normal;
  }
  .dropdown {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% - 1px);
    color: $tertiary;
    background: #fff;
    border: 1px solid $secondary;
    border: 1px solid var(--q-secondary) !important;
    border-radius: 0px 0px 3px 3px;
    z-index: 3;
    transition: all 0.3s ease-in-out;
    // &:nth-child(1),
    // &:nth-child(2),
    // &:nth-child(3),
    // &:nth-child(4) {
    //   top: calc(100% - 1px);
    //   bottom: auto;
    // }
    .q-item {
      min-height: 30px;
      padding: 2px 10px;
      flex-wrap: nowrap;
      background: #fff;
      i {
        color: $tertiary;
      }
      .q-item__section {
      }
    }
    .q-item__section--avatar {
      min-width: 24px;
      padding-right: 5px;
      justify-content: center;
    }
    .q-item__section--main {
      font-size: 12px !important;
      color: #314154;
    }
    .q-radio__inner {
      width: 0.4em;
      min-width: 0.4em;
      height: 0.4em;
    }
    .q-hoverable:hover .q-focus-helper {
      background: $secondary;
      background: var(--q-secondary) !important;
    }
  }
  .q-btn__wrapper {
    width: auto;
  }
  &:hover .q-btn--rectangle {
    border-radius: 3px 3px 0px 0px;
  }
  &:hover .q-btn--outline .q-btn__wrapper:before {
    border-color: $secondary;
    border-color: var(--q-secondaryOnBody) !important;
  }
  .hover:hover .dropdown {
    display: block;
  }
  .add-cart {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    justify-content: center;
    background: $white;
    color: $tertiary;
    border: 1px solid $secondary;
    border: 1px solid var(--q-secondaryOnBody) !important;
    border-radius: 5px;
    cursor: pointer;
    .icon,
    .btn,
    .arrow {
      padding: 10px 15px;
      min-height: 17px;
      @media (max-width: 767px) {
        // padding-left: 8px !important;
        // padding-right: 8px !important;
        padding: 10px;
      }
      @media (max-width: 374px) {
        padding-left: 4px !important;
        padding-right: 4px !important;
      }
    }
    .arrow {
      @media (max-width: 374px) {
        padding-left: 10px !important;
        padding-right: 10px !important;
      }
    }
    .icon {
      padding: 10px;
      line-height: 16px;
      display: none;
      i {
        font-size: 14px;
      }
    }
    &.addDelivery .icon {
      display: flex;
    }
    .btn {
      font-size: 14px;
      padding: 10px 15px;
    }
    .arrow {
      border-left: 1px solid $secondary;
      border-left: 1px solid var(--q-secondary) !important;
      .ar {
        line-height: 13px;
      }
      i {
        font-size: 12px;
        @media (max-width: 767px) {
          font-size: 16px;
        }
      }
      .dropdown {
        left: 0px;
        right: 0px;
      }
    }
    &.addDelivery {
      background: $secondary;
      background: var(--q-secondary) !important;
      color: $secondary;
      color: var(--q-secondaryText) !important;
      border: 1px solid $secondary;
      border: 1px solid var(--q-secondaryOnBody) !important;
      cursor: pointer;
      .arrow {
        border-left: 1px solid $secondary;
        border-left: 1px solid var(--q-secondary) !important;
      }
      .btn {
        padding: 10px 5px;
        @media (max-width: 767px) {
          padding: 10px 10px 10px 0px;
        }
        @media (max-width: 375px) {
          font-size: 12px;
        }
      }
    }
  }
  .added-cart {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    color: $tertiary;
    // border: 1px solid $secondary;
    border: 1px solid var(--q-secondaryOnBody) !important;
    // outline: 1px solid var(--q-secondaryOnBody);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    position: relative;
    .icon,
    .btn {
      // padding: 10px 8px;
      min-height: 17px;
      @media (max-width: 374px) {
        padding-left: 0;
        padding-right: 0;
      }
    }
    .icon {
      padding: 9px 10px;
      background: $secondary;
      background: var(--q-secondary) !important;
      color: var(--q-secondaryText) !important;
      line-height: 16px;
      cursor: pointer;
      border-radius: 0;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      i {
        font-size: 14px;
      }
    }
    .btn {
      flex: 10000 0 0%;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      @media (max-width: 1024px) {
        width: 85px;
      }
      .q-btn {
        flex: 0 0 50px;
        @media (max-width: 1024px) {
          flex: 0 0 30px;
        }
        .q-focus-helper,
        .q-ripple {
          display: none;
        }
        @media (max-width: 374px) {
          flex: 0 0 36px;
        }
      }
      .q-field {
        flex: 10000 0 0%;
        @media (max-width: 991px) {
          font-size: 10px;
        }
      }
    }
    .q-field__control,
    .q-field__marginal {
      height: 35px;
      padding: 0;
    }
    .q-field__native {
      text-align: center;
    }
    .q-field--outlined .q-field__control:before,
    .q-field--outlined .q-field__control:after {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }

  // START: Bottom
  &:hover .add-cart {
    border-radius: 5px 5px 0px 0px;
  }
  &:hover .addDelivery {
    border-radius: 5px 5px 5px 5px;
  }
  &.no-rounder:hover {
    .add-cart.addDelivery,
    .added-cart {
      border-radius: 5px 5px 0 0;
      .icon {
        border-top-left-radius: 0;
      }
    }
    .added-cart {
      .dropdown {
        left: -1px;
        right: -1px;
      }
    }
    .addDelivery {
      border-radius: 5px;
    }
  }
  // END: Bottom

  // START: Top
  &.top {
    .dropdown {
      border: 1px solid $secondary;
      border: 1px solid var(--q-secondaryOnBody) !important;
      top: auto;
      bottom: calc(100% - 1px);
      border-radius: 3px 3px 0px 0px;
    }
    &:hover .add-cart {
      border-radius: 0px 0px 5px 5px;
    }
    &:hover .addDelivery {
      border-radius: 5px 5px 5px 5px;
    }
    &.no-rounder:hover {
      .add-cart.addDelivery,
      .added-cart {
        border-radius: 0px 0px 5px 5px;
      }
    }
  }
  // END: Top

  // START: Loader
  &.product-cart-loading {
    .added-cart {
      .q-inner-loading {
        svg {
          position: absolute;
          left: 10px;
          //  @media (max-width: 767px) {
          //    left:20px;
          // }
        }
      }
    }
    .add-cart {
      .q-inner-loading {
        svg {
          position: absolute;
          right: 10px;
        }
      }
    }
    .delivery-mode,
    .ar {
      opacity: 0.3;
      transition: opacity 0.1s;
      -webkit-transition: opacity 0.1s;
    }
  }
  // END: Loader

  // START: Out of Stock
  .btn-outstock {
    min-height: 39px;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
    background: rgba(255, 0, 0, 0.1);
    color: rgba(255, 0, 0, 1);
    display: block;
    border-radius: 5px;
  }

  // END: Out of Stock
} */

.q-product-slider,
.discount-content {
  .product-cart {
    .dropdown {
      border: 1px solid $secondary;
      border: 1px solid var(--q-secondaryOnBody) !important;
      top: auto;
      bottom: calc(100% - 1px);
      border-radius: 3px 3px 0px 0px;
    }
    &:hover .add-cart {
      border-radius: 0px 0px 5px 5px;
    }
    &:hover .addDelivery {
      border-radius: 5px 5px 5px 5px;
    }
    &.no-rounder:hover {
      .add-cart.addDelivery,
      .added-cart {
        border-radius: 0px 0px 5px 5px;
      }
    }
  }
}
.error {
  color: red;
  width: 100%;
  font-size: 10px;
  position: absolute;
  font-weight: bold;
  top: 40px;
  &.top {
    top: -13px;
  }
}

.disable {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
.notify-custom-mobile-postion {
  @media (max-width: 767px) {
    margin-top: -96px;
  }
}
.product-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* DETAIL PAGE */
.product-detail-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

/* SMALL ICON BUTTON */
.notify-btn {
  width: 44px;
  min-width: 44px;
  height: 35px;

  border-radius: 5px;
  background: #fff4e5 !important;
  color: #ff9800 !important;
  border: 1px solid #ffe0b2;
}

/* FULL BUTTON */
.notify-full-btn {
  height: 44px;
  padding: 0 18px;

  border-radius: 5px;
  background: #fff8e1 !important;
  color: #f59e0b !important;
  border: 1px solid #fde68a;
  font-size: 14px;
  font-weight: 600;

  white-space: nowrap;
}

/* OUT OF STOCK */
.outstock-btn {
  height: 35px;
  width: 100% !important;
  // padding: 0 24px;
  background: #ffebee;
  border: 1px solid #ffcdd2;
  color: #d32f2f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  border-radius: 5px;
}

.product-detail-actions {
  display: flex !important;
  align-items: center;
  gap: 8px;
}

.product-detail-actions .outstock-btn {
  width: fit-content !important;
  height: 44px;
  padding: 0 24px;
}
</style>
